import { Record } from 'immutable';

const EventCollisionInfoRecord = Record({
  create_party: null,
  id: '0_0',
  event_name: null,
  start_date: null,
  end_date: null,
  first_name: null,
  last_name: null,
  email: null,
  phone: null,
  fax: null,
  event_party_id: null,
  chain: null,
  brand: null,
  property_id: null,
  property_address: null,
  property_zip: null,
  property_city: null,
  property_state: null,
  property_country: null,
  agency_id: null,
  name: null,
  dba_name: null,
  line1: null,
  line2: null,
  line3: null,
  city: null,
  state: null,
  postal_code: null,
  country_code: null,
  event_reference_number: null,
  auto_generated_code: null,
  manually_added: null,
  subscriber: 'Y',
});

export class EventCollisionInfo extends EventCollisionInfoRecord {
  create_party: string;
  id: string;
  event_name: string;
  start_date: string;
  end_date: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  fax: string;
  event_party_id: string;
  chain: string;
  brand: string;
  property_id: string;
  property_address: string;
  property_zip: string;
  property_city: string;
  property_state: string;
  property_country: string;
  agency_id: string;
  name: string;
  dba_name: string;
  line1: string;
  line2: string;
  line3: string;
  city: string;
  state: string;
  postal_code: string;
  country_code: string;
  event_reference_number: string;
  auto_generated_code: string;
  manually_added: string;
  subscriber: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/event-collision-info.ts